module.exports = __webpack_public_path__ + "static/img/environment_03.234a47e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hmStyle/environment_03.png
// module id = X4e8
// module chunks = 34